/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'deleteCustomerDealerEatLimitsBySystemGameTypeId',
    message: messages.SUCCESS_DELETE_CUSTOMER_DEALER_EAT_LIMITS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'DELETE',
    path: '/customer/:customerId/dealer-eat-limits/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_DEALER_EAT_LIMIT,
    requestSchema: requestSchemas.customerDealerEatLimits.deleteCustomerDealerEatLimitsBySystemGameTypeId,
  },
  {
    action: 'getCustomerDealerEatLimitsBySystemGameTypeId',
    message: messages.SUCCESS_GET_CUSTOMER_DEALER_EAT_LIMITS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'GET',
    path: '/customer/:customerId/dealer-eat-limits/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_DEALER_EAT_LIMIT,
    requestSchema: requestSchemas.customerDealerEatLimits.getCustomerDealerEatLimitsBySystemGameTypeId,
    scopes: [
      scopes.CUSTOMER_DEALER_EAT_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID,
      scopes.CUSTOMER_DEALER_EAT_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID,
      scopes.DEFAULT,
    ],
  },
  {
    action: 'saveCustomerDealerEatLimitsBySystemGameTypeId',
    message: messages.SUCCESS_SAVE_CUSTOMER_DEALER_EAT_LIMITS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'POST',
    path: '/customer/:customerId/dealer-eat-limits/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.SAVE_CUSTOMER_DEALER_EAT_LIMIT,
    requestSchema: requestSchemas.customerDealerEatLimits.saveCustomerDealerEatLimitsBySystemGameTypeId,
  },
  {
    action: 'updateCustomerDealerEatLimitsBySystemGameTypeId',
    message: messages.SUCCESS_UPDATE_CUSTOMER_DEALER_EAT_LIMITS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'PATCH',
    path: '/customer/:customerId/dealer-eat-limits/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_DEALER_EAT_LIMIT,
    requestSchema: requestSchemas.customerDealerEatLimits.updateCustomerDealerEatLimitsBySystemGameTypeId,
  },
];
